import urls from '../constants/urls';

import { gatherErrors } from '../utils/errorHandling';
import {
  CHECKING_UNIQUENESS,
  CHECKING_UNIQUENESS_FAILED,
  UNIQUENESS,
} from './numbers';

export const UPDATE_NUMBER_FAILED = 'number/UPDATE_NUMBER_FAILED';
export const UPDATE_NUMBER_SUCCESS = 'number/UPDATE_NUMBER_SUCCESS';
export const UPDATING_NUMBER = 'number/UPDATING_NUMBER';

export const LOADING_NUMBER = 'number/LOADING_NUMBER';
export const NUMBER_LOAD_FAILED = 'number/NUMBER_LOAD_FAILED';
export const NUMBER_LOAD_SUCCESS = 'number/NUMBER_LOAD_SUCCESS';

const initialState = {
  number: null,

  updateErrors: {},

  failedLoading: false,

  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_NUMBER:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case NUMBER_LOAD_SUCCESS:
      return {
        ...state,
        number: action.payload.data.data,
        isLoading: false,
      };

    case NUMBER_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    case UPDATING_NUMBER:
      return {
        ...state,
        updateErrors: {},
        isSaving: true,
        failedSaving: false,
      };

    case UPDATE_NUMBER_SUCCESS:
      return {
        ...state,
        updateErrors: {},
        isSaving: false,
      };

    case UPDATE_NUMBER_FAILED:
      return {
        ...state,
        updateErrors: gatherErrors(action.error, 'update_number_failed'),
        isSaving: false,
        failedSaving: true,
      };

    default:
      return state;
  }
};

export const loadNumber = (hospitalId, numberId) => dispatch => {
  return dispatch({
    types: [LOADING_NUMBER, NUMBER_LOAD_SUCCESS, NUMBER_LOAD_FAILED],
    payload: {
      request: {
        url: urls.hospitals.numbers.show(hospitalId, numberId),
      },
    },
  });
};

export const updateNumber = (hospitalId, numberId, params) => dispatch => {
  const numberParams = {
    extension: params.extension,
    name: params.name,
    number_type: params.number_type,
    marked_incorrect_counter: params.marked_incorrect_counter,
  };

  return dispatch({
    types: [UPDATING_NUMBER, UPDATE_NUMBER_SUCCESS, UPDATE_NUMBER_FAILED],
    payload: {
      request: {
        method: 'patch',
        url: urls.hospitals.numbers.update(hospitalId, numberId),
        data: { number: numberParams },
      },
    },
  });
};

export const checkUniqueness = (hospitalId, numberId, params) => dispatch => {
  const numberParams = {
    extension: params.extension,
    name: params.name,
    number_type: params.number_type,
  };

  return dispatch({
    types: [CHECKING_UNIQUENESS, UNIQUENESS, CHECKING_UNIQUENESS_FAILED],
    payload: {
      request: {
        method: 'get',
        url: urls.hospitals.numbers.edit(hospitalId, numberId),
        params: numberParams,
      },
    },
  });
};
